import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ETLIACopyStatus, ETLIACopyStatusOfferProviderResponse, ETLIACopyStatusOfferResult, ETLIACopyStatusProviderResult } from '../../../models/data-feed.model';
import { EtlMonitorService } from '../../../services/etl-monitor.service';

@Component({
  selector: 'app-ia-copy-report-dialog',
  templateUrl: './ia-copy-report-dialog.component.html',
  styleUrls: ['./ia-copy-report-dialog.component.scss']
})
export class IACopyReportDialogComponent implements OnInit {
  runId: string;
  fileName: string;

  iaCopyStatus: ETLIACopyStatus | null = null;
  loading = true;
  error: string | null = null;
  providerNameById = new Map<string, string>();

  constructor(
    public dialogRef: MatDialogRef<IACopyReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { runId: string; fileName: string },
    private etlMonitorService: EtlMonitorService
  ) {
    this.runId = data.runId;
    this.fileName = data.fileName;
  }

  //ordered provider columns for the offer×provider table
  providers: ETLIACopyStatusProviderResult[] = [];

  ngOnInit(): void {
    //on-demand load for this item only
    this.etlMonitorService.getIACopyStatus(this.runId).subscribe(
      (status) => {
        this.loading = false;
        this.iaCopyStatus = status;
        if (status) {
          this.providers = status.ProviderResults || [];
        } else {
          this.error = 'No IA copy details found for this run.';
        }
      },
      () => {
        this.loading = false;
        this.error = 'Failed to load IA copy details.';
      }
    );
  }

  //the offer's response for a given provider column (undefined if that provider produced none)
  responseFor(offer: ETLIACopyStatusOfferResult, providerId: string): ETLIACopyStatusOfferProviderResponse | undefined {
    return (offer.Responses || []).find((r) => r.ProviderId === providerId);
  }

  //human-readable duration from milliseconds (ms → s → m s)
  formatDuration(ms?: number | null): string {
    const value = ms ?? 0;
    if (value < 1000) {
      return `${value} ms`;
    }
    const totalSeconds = value / 1000;
    if (totalSeconds < 60) {
      return `${totalSeconds.toFixed(1)} s`;
    }
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.round(totalSeconds % 60);
    return `${minutes} m ${seconds} s`;
  }

  //status → color class for badge/cell coding
  statusClass(status?: string | null): string {
    switch ((status || '').toLowerCase()) {
      case 'completed': return 'status-completed';
      case 'pending': return 'status-pending';
      case 'failed': return 'status-failed';
      default: return 'status-none';
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
